/**
 * Spinner component - loading indicator with skeleton UI
 */
export class Spinner {
  private container: HTMLElement | null = null;

  constructor(private containerId: string) {}

  /**
   * Create and show spinner
   */
  public show(): void {
    if (this.container) {
      console.warn('[CaredoveWidget] Spinner already exists');
      return;
    }

    const targetElement = document.getElementById(this.containerId);
    if (!targetElement) {
      console.error(`[CaredoveWidget] Cannot show spinner: element ${this.containerId} not found`);
      return;
    }

    const spinnerDiv = document.createElement('div');
    spinnerDiv.className = 'caredove-spinner';
    spinnerDiv.innerHTML = `
      <div class="caredove-skeleton">
        <div class="caredove-skeleton__title"></div>
        <div class="caredove-skeleton__paragraph">
          <div class="caredove-skeleton__line"></div>
          <div class="caredove-skeleton__line"></div>
          <div class="caredove-skeleton__line"></div>
          <div class="caredove-skeleton__line"></div>
          <div class="caredove-skeleton__line"></div>
          <div class="caredove-skeleton__line"></div>
          <div class="caredove-skeleton__line"></div>
          <div class="caredove-skeleton__line"></div>
        </div>
      </div>
    `;

    targetElement.appendChild(spinnerDiv);
    this.container = spinnerDiv;
  }

  /**
   * Hide and remove spinner
   */
  public hide(): void {
    if (this.container) {
      this.container.remove();
      this.container = null;
    }
  }

  /**
   * Check if spinner is currently shown
   */
  public isVisible(): boolean {
    return this.container !== null;
  }

  /**
   * Set auto-hide timeout
   */
  public autoHide(milliseconds: number): void {
    setTimeout(() => {
      this.hide();
    }, milliseconds);
  }
}
